function getGridSize() {
  return ($(window).innerWidth() < 576) ? 1 :
    ($(window).innerWidth() < 768) ? 2 :
      ($(window).innerWidth() < 992) ? 3 : 4;
};
$(document).ready(function() {
  $(".course-slider__holder").slick({
    adaptiveHeight: true,
    arrows: true,
    dots: false,
    prevArrow: '<button type="button" class="prev"></button>',
    nextArrow: '<button type="button" class="next"></button>',
    appendArrows: $('.course-slider .course-slider__nav'),
    slidesToShow: getGridSize()
  });
});
$(window).on('load resize', function() {
  var pos = ($(window).width() < 992) ? 'left' : 'top';
  $('[data-toggle="tooltip"]').tooltip({'placement': pos});
}).trigger('resize');
